import React, { ReactNode, FunctionComponent } from 'react';
import { useSharedSelectionArea, UndefineSharedSelectionAreaContext } from './SharedSelectionArea';
import { useCss } from 'app/utils/css';
import { KeyPath } from 'app/models/entityStateSync/keypath';

interface IProps {
  path: KeyPath;
  /**
   * Whether to treat the selection as "all seleted". Use this when
   * a string is possibly represented differently between clients
   * depending on their locale, for example translated UI strings
   * or dates.
   */
  block?: boolean;
  /**
   * Render as inline (span) or block (div)
   */
  inline?: boolean;
  /**
   * Render inheriting flex and sizing properties. This is so that
   * it can be used in places where it should match the size of
   * its container and also impose its size on its children
   */
  inheritFlex?: boolean;
  children: ReactNode;
}

const SharedSelection: FunctionComponent<IProps> = ({ path, block, inline, inheritFlex, children }) => {
  const css = useCss();
  const area = useSharedSelectionArea(path, block ?? false);

  const Wrap = inline ? 'span' : 'div';
  const wrapClass = css('sharedSelectionWrap', [
    { position: 'relative' },

    inheritFlex && {
      display:        'inherit',
      flex:           'inherit',
      justifyContent: 'inherit',
      alignItems:     'inherit',
      flexDirection:  'inherit',
      width:          'inherit',
      height:         'inherit',
      maxWidth:       'inherit',
      maxHeight:      'inherit',
    },
  ]);

  return (
    <Wrap ref={area.setRef} className={wrapClass}>
      <UndefineSharedSelectionAreaContext>
        {children}
      </UndefineSharedSelectionAreaContext>
    </Wrap>
  );
};

export default SharedSelection;
